import React, { useMemo } from 'react';
import { useQuery } from '@apollo/client';
import { gqlGetCollectionOrderStatusHistoryByOrderId } from '../../queries';
import { CellDateTimeV8, CellDateV8, TableCellV8, TablePaginatedV8 } from 'motion-components';
import { useTranslation } from 'react-i18next';
import { useRootStore } from 'store';
import { TabContextTitle } from '../components/tab-context-title';

export const ActionsHistoryTabContent = ({ collectionOrderId }: { collectionOrderId: number }) => {
  const { appStore, tableStore } = useRootStore();
  const { t } = useTranslation();
  const { data, loading } = useQuery(gqlGetCollectionOrderStatusHistoryByOrderId, {
    variables: { id: collectionOrderId },
    fetchPolicy: 'cache-and-network',
    notifyOnNetworkStatusChange: true,
  });

  const columns = useMemo(
    () => [
      {
        id: 'actionDate',
        header: t('Ημερομηνία Ενέργειας'),
        columnName: t('Ημερομηνία Ενεργειας'),
        accessorKey: 'actionDate',
        orderByField: 'actionDate',
        cell: CellDateTimeV8,
        size: 30,
        meta: { type: 'text' },
      },
      {
        id: 'user',
        header: t('Χρήστης'),
        columnName: t('Χρήστης'),
        accessorKey: 'user.firstName',
        orderByField: 'user.firstName',
        cell: ({ row }: { row: any }) => {
          return (
            <div>
              {row.original.user.firstName} {row.original.user.lastName}
            </div>
          );
        },
      },
      {
        id: 'action',
        header: t('Ενέργεια'),
        columnName: t('Ενέργεια'),
        accessorKey: 'collectionOrderAction.name',
        orderByField: 'collectionOrderAction.name',
      },
      {
        id: 'oldStatus',
        header: t('Προηγούμενη Κατάσταση'),
        columnName: t('Προηγούμενη Κατάσταση'),
        accessorKey: 'oldStatus.name',
        orderByField: 'oldStatus.name',
      },
      {
        id: 'newStatus',
        header: t('Νέα Κατάσταση'),
        columnName: t('Νέα Κατάσταση'),
        accessorKey: 'newStatus.name',
        orderByField: 'newStatus.name',
      },
    ],
    [t],
  );

  const orderedData = useMemo(() => {
    const source = data?.getCollectionOrderStatusHistoryByOrderId?.data;
    if (!Array.isArray(source)) return [];
    return [...source].sort((a: any, b: any) => a.id - b.id);
  }, [data]);

  return (
    <div>
      <TabContextTitle label={t('Ιστορικό Ενεργειών')} badge="I" />

      {/* TableGrid */}
      {data ? (
        <TablePaginatedV8
          style={{ overflow: 'visible' }}
          appStore={appStore}
          tableStore={tableStore}
          loading={loading}
          id="actions-history-grid"
          key="grid"
          columns={columns as any}
          data={orderedData}
          dataCount={data.getCollectionOrderStatusHistoryByOrderId.recordCount}
          topBorderRadius={false}
          initSorting={[{ id: 'actionDate', desc: false }]}
        />
      ) : (
        <div style={{ height: '200px' }}></div>
      )}
    </div>
  );
};
